export default defineNuxtRouteMiddleware(() => {
    const user = useState('profile').value
    const isAdmin = user?.account_type === 'admin' || (user?.impersonate && user?.initial_user?.account_type === 'admin')

    if (!isAdmin) {
        return abortNavigation(createError({ statusCode: 403, statusMessage: 'Accès refusé' }))
    }
})
